export const ARROW_RIGHT_KEY = { key: "ArrowRight", code: 39 }

export const PAGE_UP_KEY = { key: "PageUp", code: 33 }
export const PAGE_DOWN_KEY = { key: "PageDown", code: 34 }

export const HOME_KEY = { key: "Home", code: 36 }
export const END_KEY = { key: "End", code: 35 }

export const ENTER_KEY = { key: "Enter", code: 13, charCode: 13 }
export const SPACE_KEY = { key: " ", code: "Space", keyCode: 49 }
export const ESCAPE_KEY = { key: "Escape", code: 27 }
export const A_KEY = { key: "a", code: 65 }

export function isUnmodifiedKeyPress(event: React.KeyboardEvent) {
  return !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey
}
export function isShiftKeyPress(event: React.KeyboardEvent) {
  return !event.ctrlKey && !event.metaKey && !event.altKey && event.shiftKey
}
export function isCommandKeyPress(event: React.KeyboardEvent) {
  return (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey
}
